import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 36,
	viewBox: "0 0 48 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.00186522 8.62513H47.9991V6.63437C47.9991 2.22637 45.705 0 41.1363 0H6.8646C2.29691 0 0.000932719 2.22637 0.000932719 6.63528L0.00186522 8.62513ZM0.00186522 29.3866C0.00186522 33.7955 2.29597 36 6.8646 36H41.1363C45.704 36 48 33.7955 48 29.3866V13.4842H0L0.00186522 29.3866ZM7.30198 24.1641V20.2045C7.30198 19.0063 8.15434 18.1498 9.44407 18.1498H14.7989C16.0886 18.1498 16.941 19.0063 16.941 20.2045V24.1641C16.941 25.3841 16.0886 26.2188 14.7989 26.2188H9.44314C8.15341 26.2188 7.30198 25.3841 7.30198 24.1641Z",
		fill: "white",
		fillOpacity: .34
	})]
});
const ForwardRef = forwardRef(SvgCard);
export default ForwardRef;
